import { endpoints } from 'endpoints.config';
import { ForgottenPasswordPost } from './models';
import instance from 'api';

export type ApiReturn<T = any> = {
  response: T | null;
  errors: Error[] | null;
};

export const PostForgottenPassword = async (
  payload: ForgottenPasswordPost
): Promise<ApiReturn> => {
  try {
    const res = await instance.post(
      endpoints.forgottenPassword.requestPasswordReset,
      payload
    );
    if (res.data.status === '1') {
      return {
        response: res.data.details,
        errors: null,
      };
    } else {
      return {
        response: res.data.details,
        errors: res.data.errors,
      };
    }
  } catch (err: any) {
    return {
      response: null,
      errors: err,
    };
  }
};
